__turbopack_context__.v({
  "badge": "subscription-days-badge-module-scss-module__eR2IYa__badge",
  "badge_expiring": "subscription-days-badge-module-scss-module__eR2IYa__badge_expiring",
  "icon": "subscription-days-badge-module-scss-module__eR2IYa__icon",
  "text": "subscription-days-badge-module-scss-module__eR2IYa__text",
  "textDefault": "subscription-days-badge-module-scss-module__eR2IYa__textDefault",
  "textHover": "subscription-days-badge-module-scss-module__eR2IYa__textHover",
  "text_highlight": "subscription-days-badge-module-scss-module__eR2IYa__text_highlight",
});
